import { render, staticRenderFns } from "./BatchModelUpload.vue?vue&type=template&id=0548ec87&scoped=true"
import script from "./BatchModelUpload.vue?vue&type=script&lang=js"
export * from "./BatchModelUpload.vue?vue&type=script&lang=js"
import style0 from "./BatchModelUpload.vue?vue&type=style&index=0&id=0548ec87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0548ec87",
  null
  
)

export default component.exports